import moment from 'moment'
require('twix') // TODO: find a way to use es6 style.

import {Map, fromJS, List} from 'immutable'

import {
  SCHEDULE_ENTRIES,
  SCHEDULE_SLOT_SPAN
} from '../../config/constants'

import {
  SET_USER_SCHEDULE
} from '../action_types'

import getDailyAvailabilitySlots from '../helpers/get_empty_daily_availability_slots'

const addRangeObjectToEntry = (entry) => {
  return entry.set('range', moment(entry.get('startTime')).twix(entry.get('endTime')))
}

const addEventAttributesToEntry = (entry) => {
  let updatingEntry = entry
    .set('start', moment(entry.get('startTime')).toDate())
    .set('end', moment(entry.get('endTime')).toDate())

  const type = entry.get('type')
  const otherUserName = entry.getIn(['payload', 'otherUser', 'name'])

  if (type === SCHEDULE_ENTRIES.AVAILABLE_TIME) {
    updatingEntry = updatingEntry
      .set('title', 'Available Time')
      .set('className', 'schedule-event available-time')
  }
  else if (type === SCHEDULE_ENTRIES.BOOKED) {
    let title = 'Booked Session'

    if (otherUserName) title += ' with ' + otherUserName

    updatingEntry = updatingEntry
      .set('className', 'schedule-event booked-session')
      .set('title', title)
  }

  return updatingEntry
}

const injectKeys = (entry, key) => entry.merge({key})

const transformSchedule = (schedule) => {
  return schedule
    .map(addRangeObjectToEntry)
    .map(addEventAttributesToEntry)
    .map(injectKeys)
}

const mappedSchedule = (rawSchedule) => {
  return Map({}).withMutations((schedule) => {
    rawSchedule.map((rawEntries) => {
      rawEntries.get('range').split(1, 'day').map((dayRange) => {
        const day = dayRange.start()
        const dayOfYear = day.dayOfYear()

        const existingSlots = schedule.getIn([dayOfYear.toString(), 'slots']) || List(getDailyAvailabilitySlots())

        const slots = existingSlots.withMutations((existingSlots) => {
          dayRange.split(SCHEDULE_SLOT_SPAN, 'minute')
          .forEach((minuteRange) => {
            const slotStartTime = minuteRange.start()
            let minutes = slotStartTime.diff(moment(slotStartTime).startOf('day'), 'minutes')
            let slotIndex = 0
            if (minutes > 0) slotIndex = minutes / SCHEDULE_SLOT_SPAN
            existingSlots.set(slotIndex, {available: true, startTime: slotStartTime})
          })
        })

        schedule.mergeDeep({[dayOfYear]: {day, slots, index: dayOfYear}})
      })
    })
  })
}

export default (state = Map({}), action) => {
  switch (action.type) {
    case SET_USER_SCHEDULE:
      const schedule = fromJS(action.schedule)
      const raw = transformSchedule(schedule).toList()
      const mapped = mappedSchedule(raw)
      // const availability = retrieveAvailabilitySlots(mapped)

      return state.mergeDeep({[action.uid]: {raw, mapped /*, availability*/}})

    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/reducers/schedules.js
 **/